import React, { useContext, useRef, useState } from "react";
import {
  Button,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import UsageRatePlan from "./UsageRatePlan";
import UsageRatePlanRecurring from "./UsageRatePlanRecurring";
import { usageTabChange } from "./constants/displayInfinite";
import {
  isEmptyOrInvalidField,
  isEmptyOrInvalidFieldRecurring,
} from "./constants/checkEmptyFields";
import { CreateOfferContext } from "./context";
import { CycleAlignmentOption, recurringFrequencyOptions } from "./constants/initialValues";

const Usage = () => {
  const {
    isSubscribed,
    values,
    touched,
    setTouched,
    usageActiveTab,
    setUsageActiveTab,
  } = useContext(CreateOfferContext);
  const pushOneTimeRef = useRef(null);
  const pushRecurringRef = useRef(null);
  return (
    <Row className="mb-4">
      <Col lg={12}>
        {values?.usageRatePlan?.length === 0 &&
        values?.recurringUsageRatePlan?.length === 0 ? (
          <div
            className="d-flex flex-column justify-content-center align-items-center"
            style={{ marginTop: "120px" }}
          >
            {isSubscribed ? (
              <div className="text-center mb-2">
                There are no Usage available for this offer.
              </div>
            ) : (
              <div className="text-center mb-2">
                There are no Usage available for this offer, Add a Usage to
                proceed.
              </div>
            )}
            {!isSubscribed && (
              <Button
                color="secondary"
                className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 text-nowrap mt-0"
                onClick={() => {
                  const lastIndex = values.recurringUsageRatePlan.length - 1;
                  if (
                    lastIndex === -1 ||
                    !isEmptyOrInvalidFieldRecurring(lastIndex, values)
                  ) {
                    pushRecurringRef.current &&
                      pushRecurringRef.current({
                        usageId: "",
                        eventType: "",
                        unitOfMeasurement: "",
                        priority: "",
                        type: "1",
                        balanceImpacts: [
                          {
                            resourceName: "",
                            flatRate: "",
                            validityStart: "",
                            validityEnd: "",
                            pricingModel: "",
                            pricingModelNew: [],
                            perUnitRate: "",
                            startDateTime: null,
                            timeUnit: "",
                            endDateTime: null,
                            perUnitRate: "",
                            recurringFrequency: recurringFrequencyOptions[0],
                            recurringFrequencyUnit: 1,
                            cycleAlignment: CycleAlignmentOption[1],
                          },
                        ],
                        attributeBasedDetails: [], // Add this field
                      });
                    setTouched({
                      ...touched,
                      recurringUsageRatePlan: {
                        ...touched.recurringUsageRatePlan,
                        [lastIndex]: {
                          usageId: false,
                          eventType: false,
                          recurringFrequency: false,
                          cycleAlignment: false,
                          resourceName: false,
                          unitOfMeasurement: false,
                          priority: false,
                          perUnitRate: false,
                          flatRate: false,
                          pricingModel: false,
                          validityStart: false,
                          validityEnd: false,
                          balanceImpacts: [
                            {
                              resourceName: false,
                              flatRate: false,
                              validityStart: false,
                              validityEnd: false,
                              pricingModel: false,
                              pricingModelNew: false,
                              perUnitRate: false,
                              startDateTime: false,
                              timeUnit: false,
                              endDateTime: false,
                              perUnitRate: false,
                              recurringFrequency: false,
                              cycleAlignment: false,
                            },
                          ],
                          attributeBasedDetails: [], // Add this field
                        },
                      },
                    });
                  }
                }}
              >
                <i className="ri-add-fill label-icon align-middle fs-16 me-2"></i>{" "}
                <span className="px-0 ps-2 ms-2 me-1">Add Usage </span>
              </Button>
            )}
          </div>
        ) : (
          <div className="mx-0 d-flex">
            {!isSubscribed && (
              <Button
                color="secondary"
                className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-0 text-nowrap mb-1 ms-auto"
                onClick={() => {
                  const lastIndex = values.recurringUsageRatePlan.length - 1;
                  if (
                    lastIndex === -1 ||
                    !isEmptyOrInvalidFieldRecurring(lastIndex, values)
                  ) {
                    pushRecurringRef.current &&
                      pushRecurringRef.current({
                        usageId: "",
                        eventType: "",
                        unitOfMeasurement: "",
                        priority: "",
                        type: "1",
                        balanceImpacts: [
                          {
                            resourceName: "",
                            flatRate: "",
                            validityStart: "",
                            validityEnd: "",
                            pricingModel: "",
                            pricingModelNew: [],
                            perUnitRate: "",
                            startDateTime: null,
                            timeUnit: "",
                            endDateTime: null,
                            perUnitRate: "",
                            recurringFrequency: recurringFrequencyOptions[0],
                            recurringFrequencyUnit: 1,
                            cycleAlignment: CycleAlignmentOption[1],
                          },
                        ],
                        attributeBasedDetails: [], // Add this field
                      });
                    setTouched({
                      ...touched,
                      recurringUsageRatePlan: {
                        ...touched.recurringUsageRatePlan,
                        [lastIndex]: {
                          usageId: false,
                          eventType: false,
                          recurringFrequency: false,
                          cycleAlignment: false,
                          resourceName: false,
                          unitOfMeasurement: false,
                          priority: false,
                          perUnitRate: false,
                          flatRate: false,
                          pricingModel: false,
                          validityStart: false,
                          validityEnd: false,
                          balanceImpacts: [
                            {
                              resourceName: false,
                              flatRate: false,
                              validityStart: false,
                              validityEnd: false,
                              pricingModel: false,
                              pricingModelNew: false,
                              perUnitRate: false,
                              startDateTime: false,
                              timeUnit: false,
                              endDateTime: false,
                              perUnitRate: false,
                              recurringFrequency: false,
                              cycleAlignment: false,
                            },
                          ],
                          attributeBasedDetails: [], // Add this field
                        },
                      },
                    });
                  }
                }}
              >
                <i className="ri-add-fill label-icon align-middle fs-16 me-2"></i>{" "}
                <span className="px-0 ps-2 ms-2 me-1">Add Usage </span>
              </Button>
            )}
          </div>
        )}
        <UsageRatePlanRecurring pushRef={pushRecurringRef} />
      </Col>
    </Row>
  );
};

export default Usage;
